import styled from "@emotion/styled"
import { wv_willfade } from "./../styles"
import getMediaQuery from "css/breakpoints"

export const Main = styled.section`
  ${wv_willfade}
  &.wv_reveal {
    transition-delay: 0.5s;
  }
  --spacing: 0;
  ${getMediaQuery("m")} {
    --spacing: 3.125rem;
  }
  position: absolute;
  top: 0;
  z-index: 1;
  padding-block: calc(var(--spacing) + 1ex);
  padding-inline: var(--outer-margin);
  pointer-events: none;

  ${getMediaQuery("m")} {
    .wv_ref & {
      display: none !important;
    }
  }

  & button {
    pointer-events: auto;
    // to override default button style in that case
    color: rgba(var(--green)) !important;

    .wvIncard & {
      margin-inline: 0 !important;
      margin-block: 0 !important;
    }

    svg {
      fill: rgba(var(--green)) !important;
    }

    @media (hover: hover) {
      &:hover {
        color: rgba(var(--light-black)) !important;

        svg {
          fill: rgba(var(--light-black)) !important;
        }
      }
    }
  }
`
